import { RootState } from "../../../store";

export const changeNameSelector = (state: RootState) => state.changeName;
